module.exports = __webpack_public_path__ + "static/media/wizy.2e880f70.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wizy.svg
// module id = 224
// module chunks = 0